// removed by extract-text-webpack-plugin
module.exports = {"content":"SlotsView__content___sHzDb"};